
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h10v6H0z","fill":"#002b7f"}}),_c('path',{attrs:{"d":"M0 1h10v4H0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M0 2h10v2H0z","fill":"#ce1126"}})])
          )
        }
      }
    